// 主题标签的tpyeId
const themeTagTypeId = 5;
  
// 帖子标签的typeId
const postTagTypeId = 6;
  
export {
  themeTagTypeId,
  postTagTypeId,
};